export default __webpack_public_path__ + "static/media/Malostranska_sm.37b62f39.jpg";